import { render, staticRenderFns } from "./IconNotificationBell.vue?vue&type=template&id=ed3c895c&"
import script from "./IconNotificationBell.vue?vue&type=script&lang=js&"
export * from "./IconNotificationBell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports